import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttachmentService } from '../../services/attachment.service';

@Component({
    selector: 'app-delete-restore-attachment',
    templateUrl: './delete-restore-attachment.dialog.html',
    styleUrls: ['./delete-restore-attachment.dialog.scss'],
    standalone: false
})
export class DeleteRestoreAttachmentDialog implements OnInit {
    private attachmentId: number;
    private action: string;
    private title: string;
    public actOnAllAttachments: boolean;

    constructor(public dialogRef: MatDialogRef<DeleteRestoreAttachmentDialog>, @Inject(MAT_DIALOG_DATA) data, private attachmentService: AttachmentService) {
        this.attachmentId = data.attachmentId;
        this.action = data.deleteOrRestore;
        this.title = `${data.deleteOrRestore} Attachment`;
    }

    public ngOnInit(): void {
    }

    public get Title(): string {
        return this.title;
    }

    public get IsDeleteAction(): boolean {
        return this.action == 'Delete';
    }

    public get IsRestoreAction(): boolean {
        return this.action == 'Restore';
    }

    public onCancel(): void {
        this.dialogRef.close();
    }

    public onConfirm(): void {
        if (this.IsDeleteAction) {
            this.attachmentService.disableAttachment(this.attachmentId, this.actOnAllAttachments).then(x => {
                this.dialogRef.close();
            });
        } else if (this.IsRestoreAction) {
            this.attachmentService.restoreAttachment(this.attachmentId, this.actOnAllAttachments).then(x => {
                this.dialogRef.close();
            });
        }
    }

}
